import app from '../../scripts/app';

import template from './validation-error.jade';

app.directive('cianAfValidationError', () => ({
  restrict: 'E',
  scope: {},
  bindToController: {
    message: '=',
    isVisible: '=',
  },
  controller(deviceService) {
    'ngInject';

    this.isMobile = deviceService.isMobile;
  },
  controllerAs: 'validationError',
  template,
  replate: true,
}));
